import { render, staticRenderFns } from "./pictures.vue?vue&type=template&id=49cd2959&"
import script from "./pictures.vue?vue&type=script&lang=js&"
export * from "./pictures.vue?vue&type=script&lang=js&"
import style0 from "./pictures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports